module.exports = __webpack_public_path__ + "assets/img/interaction.15599b2f.png";